import useSWR from 'swr'

export interface MetaDataFromServerInterface {
  hostOnServer: string | null
}

export const META_DATA_FROM_SERVER_KEY = 'meta-data-from-server'

export const useMetadataFromServer = () => {
  const { data } = useSWR<MetaDataFromServerInterface>(META_DATA_FROM_SERVER_KEY)

  return { data }
}
